/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_CardInputs */

const en_guide_large_json_files_card = /** @type {(inputs: Guide_Large_Json_Files_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategies for handling large JSON files efficiently. Performance tips and alternative formats.`)
};

const ko_guide_large_json_files_card = /** @type {(inputs: Guide_Large_Json_Files_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대용량 JSON 파일을 효율적으로 처리하는 전략. 성능 팁과 대안 포맷.`)
};

const ja_guide_large_json_files_card = /** @type {(inputs: Guide_Large_Json_Files_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きなJSONファイルを効率的に処理する戦略。パフォーマンスヒントと代替フォーマット。`)
};

/**
* | output |
* | --- |
* | "Strategies for handling large JSON files efficiently. Performance tips and alternative formats." |
*
* @param {Guide_Large_Json_Files_CardInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_card = /** @type {((inputs?: Guide_Large_Json_Files_CardInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_CardInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_card(inputs)
	if (locale === "ko") return ko_guide_large_json_files_card(inputs)
	return ja_guide_large_json_files_card(inputs)
});